// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fA","advertDetailContacts__header":"c-n_fB"};